import React from "react";
import pansuriyaPhoto from "./../../assets/image2.jpeg";
import { FaShieldAlt, FaStar, FaUsers, FaBuilding } from "react-icons/fa";
import "./AboutSection.css";

export default function AboutSection() {
  return (
    <section id="about" className="about1-section">
      <div className="about1-container">
        <div className="about1-grid">
          <div>
            <h2 className="about1-heading">About Pansuriya Impex</h2>
            <p className="about1-description">
              Pansuriya Impex is a premier manufacturer, seller, and exporter of
              both natural and lab-grown diamonds. With decades of expertise, we
              are dedicated to crafting diamonds of unmatched quality and
              brilliance.
            </p>
            <div className="feature1-grid">
              <div className="feature1-item">
                <FaShieldAlt className="feature1-icon" />
                <div>
                  <p className="feature1-title">Quality Assured</p>
                  <p className="feature1-text">
                    Rigorous quality control at every step
                  </p>
                </div>
              </div>
              <div className="feature1-item">
                <FaUsers className="feature1-icon" />
                <div>
                  <p className="feature1-title">Expert Team</p>
                  <p className="feature1-text">
                    Skilled craftsmen and gemologists
                  </p>
                </div>
              </div>
              <div className="feature1-item">
                <FaBuilding className="feature1-icon" />
                <div>
                  <p className="feature1-title">State-of-art Facility</p>
                  <p className="feature1-text">
                    Modern manufacturing technology
                  </p>
                </div>
              </div>
              <div className="feature1-item">
                <FaStar className="feature1-icon" />
                <div>
                  <p className="feature1-title">Premium Service</p>
                  <p className="feature1-text">
                    Personalized customer experience
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="image1-wrapper">
            <div className="image1-container1">
              <img
                src={pansuriyaPhoto}
                alt="Diamond crafting"
                className="about1-image1"
              />
              <div className="image1-overlay">
                <div className="overlay1-number">50+</div>
                <div className="overlay1-label">Years of Excellence</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
